var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--circle-10",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('div',{staticClass:"loader-xbox"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }